export const suggestionsContainerProps = {
  placement: 'bottom',
  disablePortal: false,
  modifiers: {
    flip: {
      enabled: false,
    },
    preventOverflow: {
      enabled: true,
      boundariesElement: 'window',
    },
  },
};
